module.exports = __webpack_public_path__ + "img/alert-person.d143b085.svg";